<template>
  <div class="home">
    <Header id="home" />

    <Services @run="run" :screen="screen" />

    <IllustratedContent name="services" highlight="true" imgPosition="left" />

    <IllustratedContent name="about" imgPosition="right" />

    <IllustratedContent name="pisé-stabilisé" highlight="true" imgPosition="left" />

    <IllustratedContent name="advantages" highlight="true" imgPosition="right" cover/>

    <IllustratedContent name="structures" highlight="true" imgPosition="left" />

    <Slides name="urban-furniture" imgPosition="right" @run="run" />

    <Gallery name="achievements" @run="run" />

    <Contact imgPosition="right" />

    <Footer />
  
    <PicViewer :show="show" @run="run" />
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Services from '@/components/Services.vue'
import IllustratedContent from '@/components/IllustratedContent'
import Slides from '@/components/Slides'
import Gallery from '@/components/Gallery'
import Contact from '@/components/Contact'
import PicViewer from '@/components/PicViewer.vue'
import Footer from '@/components/Footer'

export default {
  name: 'Home',
  props: [
    'screen'
  ],
  components: {
    Header,
    Services,
    IllustratedContent,
    Slides,
    Gallery,
    Contact,
    PicViewer,
    Footer,
  },
  data() {
    return {
      show: {
        viewer: false,
        selection: null,
      },
    }
  },
  methods: {
    run(method, params = null) {
      if(typeof this[method] === 'function') {
        !!params ? this[method](params) : this[method]()
      }
      else {
        this.$emit('run', method, params)
      }
    },
    openViewer( item ) {
      this.show.selection = item
      this.show.viewer = true
    },
    clearViewer() {
      this.show.selection = null
      this.show.viewer = false
    }
  },
}
</script>

<style>

</style>
